import { siteConfig } from "../config/siteConfig";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="section bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="reveal">
            <div className="grid grid-cols-2 gap-4">
              <img
                src={siteConfig.ANURADHAPURA.about1}
                alt="Ruwanwelisaya Stupa, Anuradhapura"
                className="w-full h-72 sm:h-96 object-cover rounded-3xl"
              />
              <img
                src={siteConfig.ANURADHAPURA.about2}
                alt="Sri Maha Bodhi, Anuradhapura"
                className="w-full h-72 sm:h-96 object-cover mt-12 rounded-3xl"
              />
            </div>
          </div>

          <div className="reveal">
            <p className="font-overline mb-4">About Thuruliya</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A362D] mb-6 leading-tight">
              {siteConfig.about.title}
            </h2>
            <div className="gold-divider mb-8"></div>
            <div className="space-y-5">
              {siteConfig.about.paragraphs.map((p, i) => (
                <p
                  key={i}
                  className="text-[#2C2C2C] text-base sm:text-lg leading-relaxed"
                >
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-10 grid grid-cols-3 gap-6 border-t border-[#EBE5D9] pt-8">
              <div>
                <p className="font-display text-4xl text-[#C5A059]">8+</p>
                <p className="text-xs uppercase tracking-widest text-[#5C4033] mt-1">
                  Rooms
                </p>
              </div>
              <div>
                <p className="font-display text-4xl text-[#C5A059]">2</p>
                <p className="text-xs uppercase tracking-widest text-[#5C4033] mt-1">
                  Years of Care
                </p>
              </div>
              <div>
                <p className="font-display text-4xl text-[#C5A059]">5★</p>
                <p className="text-xs uppercase tracking-widest text-[#5C4033] mt-1">
                  Guest Rated
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
